import { render } from "./PackagesRedirect.vue?vue&type=template&id=3e2c4983&scoped=true"
import script from "./PackagesRedirect.vue?vue&type=script&lang=js"
export * from "./PackagesRedirect.vue?vue&type=script&lang=js"

import "./PackagesRedirect.vue?vue&type=style&index=0&id=3e2c4983&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2c4983"]])

export default __exports__